import {
  createDomainApi,
  type ExtractEntityType,
  useApiClient,
} from '@skylabs-digital/react-proto-kit';
import { useMemo } from 'react';
import { z } from 'zod';
import { appSchema, statsSchema } from '../schemas/app.schema';
import { unwrap } from './unwrap';

/** `GET /bo/apps`, `GET /bo/apps/:id`. Sin create/update: las apps las declara el CaC. */
export const appsApi = createDomainApi('apps', appSchema, z.object({}));
export type AppEntity = ExtractEntityType<typeof appsApi>;

/** Acciones de soporte que no son CRUD: orphan / reactivate / stats. */
export function useAppActions() {
  const { connector } = useApiClient();
  // Memoizado sobre el connector: los efectos dependen de estos métodos.
  return useMemo(
    () => ({
      orphan: async (id: string) =>
        unwrap(await connector.post<{ appId: string; status: string }>(`apps/${id}/orphan`, {})),
      reactivate: async (id: string) =>
        unwrap(
          await connector.post<{ appId: string; status: string }>(`apps/${id}/reactivate`, {}),
        ),
      stats: async (id: string) =>
        statsSchema.parse(unwrap(await connector.get<unknown>(`apps/${id}/stats`))),
    }),
    [connector],
  );
}
